module.exports = __webpack_public_path__ + "img/0.ebd74685.png";